import { render } from "./LoginButton.vue?vue&type=template&id=abe0c14e"
import script from "./LoginButton.js?vue&type=script&lang=js"
export * from "./LoginButton.js?vue&type=script&lang=js"

import "./LoginButton.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__